import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Add from "@material-ui/icons/Add";
import Icon from "@material-ui/core/Icon";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  }
});

class IconLabelButtons extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    let buttonName = this.props.buttonLabel;
    let buttonComponent = "";
    let buttonFunc = "";
    if (this.props.buttonName == "ArrowBack") {
      // buttonComponent = <ArrowBack className={classes.leftIcon} />;
      buttonFunc = this.props.onButtonClick;
    } else if (this.props.buttonName == "Add") {
      // buttonComponent = <Add className={classes.rightIcon} />;
      buttonFunc = this.props.onAddButtonClick;
    } else if (this.props.buttonName == "Group") {
      // buttonComponent = <Add className={classes.rightIcon} />;
      buttonFunc = this.props.onAddGroup;
    } else if (this.props.buttonName == "Rule") {
      // buttonComponent = <Add className={classes.rightIcon} />;
      buttonFunc = this.props.onAddRule;
    }
    return (
      <Button
        variant="contained"
        color={this.props.color}
        className={classes.button}
        onClick={buttonFunc}
        // className={classes.marginRight}
      >
        {buttonComponent}
        {buttonName}
      </Button>

      // <a
      //   href="javascript:void(0)"
      //   className="btn btngoback"
      //   onClick={buttonFunc}
      // >
      //   go back
      // </a>
    );
  }
}

IconLabelButtons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(IconLabelButtons);



// WEBPACK FOOTER //
// ./src/views/Audiences/CCustomQueryBuilder/BackButton.jsx